import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService, EntityManager, EntityQuery, NamingConvention } from 'breeze-client';
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';
import { environment } from '../../../environments/environment';
import { BrewersMetadata } from '../model/metadata';
import { BrewersRegistrationHelper } from '../model/registration-helper';
import { Entities } from './entities';

// The EntityManagerProvider manages a static master manager and a per instance sandbox manager.
@Injectable()
export class EntityManagerProvider {
    private static _preparePromise: Promise<any> | null;
    private static _masterManager: EntityManager;
    static serviceName: string;

    constructor(http: HttpClient) {
        ModelLibraryBackingStoreAdapter.register();
        UriBuilderJsonAdapter.register();
        AjaxHttpClientAdapter.register(http);
        DataServiceWebApiAdapter.register();
        NamingConvention.camelCase.setAsDefault();

        EntityManagerProvider.serviceName = environment.serviceName + '/api/breeze';
        const dataService = new DataService({
            serviceName: EntityManagerProvider.serviceName,
            hasServerMetadata: false,
        });
        const masterManager = (EntityManagerProvider._masterManager = new EntityManager({
            dataService: dataService,
        }));
        const metadataStore = masterManager.metadataStore;
        metadataStore.importMetadata(BrewersMetadata.value);

        BrewersRegistrationHelper.register(masterManager.metadataStore);
    }

    async prepare(): Promise<any> {
        if (!EntityManagerProvider._preparePromise) {
            const query = EntityQuery.from('lookups');
            EntityManagerProvider._preparePromise = EntityManagerProvider._masterManager
                .executeQuery(query)
                .then(async (data) => {
                    Entities.lookups = data.results[0];
                    return Entities.lookups;
                })
                .catch((error) => {
                    EntityManagerProvider._preparePromise = null;
                    throw error;
                });
        }
        return EntityManagerProvider._preparePromise;
    }

    reset(manager: EntityManager): void {
        if (manager) {
            manager.clear();
            this.seedManager(manager);
        }
    }

    newManager(): EntityManager {
        const manager = EntityManagerProvider._masterManager.createEmptyCopy();
        this.seedManager(manager);
        return manager;
    }

    private seedManager(manager: EntityManager) {
        manager.importEntities(EntityManagerProvider._masterManager.exportEntities(null, { asString: false, includeMetadata: false }));
    }
}
